/**
 * Steps of the password recovery flow. This is UI sequencing, not a business rule —
 * nothing in the domain says the code and the new password must be separate screens.
 * Shared by the `password-recovery` capability and the legacy auth components.
 */
export const RECOVERY_STEP = {
  PASSWORD_RESET: 'password_reset',
  VALID_CODE: 'valid_code',
  PASSWORD_RECOVER: 'password_recover',
} as const;

export type RecoveryStep = (typeof RECOVERY_STEP)[keyof typeof RECOVERY_STEP];
